"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const Popup_1 = __importDefault(require("../SettingsPopup/Popup"));
const bridge_1 = require("@completeanatomy/bridge");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const i18n_1 = require("@completeanatomy/i18n");
function ToolsGrowthSettingsPopup({ particleSize, onChangeParticleSize, }) {
    const bridge = (0, bridge_1.useBridge)();
    const setSize = (value) => {
        bridge === null || bridge === void 0 ? void 0 : bridge.toolUpdateGrowth({ particleSize: value });
        bridge === null || bridge === void 0 ? void 0 : bridge.toolkitOptionsAction({
            optionType: 2,
            val: value,
            type: bridge_schema_1.ToolType.Growth,
        });
        if (onChangeParticleSize) {
            onChangeParticleSize(value);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(Popup_1.default, { title: (0, i18n_1.Localized)(i18n_1.Strings.settings.title), "data-e2e": 'ToolsGrowthSettingsPopup_ToolsSettingsPopup', children: [(0, jsx_runtime_1.jsx)(SizeSlider, { currentValue: particleSize, min: 0, max: 100, thumbClassName: "thumb", trackClassName: "track", onChange: value => setSize(value), className: "slider", "data-e2e": 'ToolsGrowthSettingsPopup_SizeSlider' }), (0, jsx_runtime_1.jsx)(Hint, { "data-e2e": 'ToolsGrowthSettingsPopup_Hint', children: (0, i18n_1.Localized)(i18n_1.Strings.tools.spurs.particleSize) })] }));
}
exports.default = ToolsGrowthSettingsPopup;
const SizeSlider = (0, styled_components_1.default)(ui_1.Slider).attrs({
    role: 'slider',
}) `
  width: 80%;
  margin: 20px auto 10px auto;

  .track {
    width: auto;
    height: 2px;
    background: ${props => props.theme.lightGrey};
  }

  .track-0 {
    background: ${props => props.theme.tools.header.textbox.colors.white};
  }
`;
const Hint = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;

  margin: 0 0 20px 0;

  color: ${props => props.theme.text};

  font-size: 14px;
`;
